var React = require('react');

function Next (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 7H36","stroke":"#F3F3F3","strokeWidth":"2","key":0}),React.createElement("path",{"d":"M30 1L37 7.5L30 14","stroke":"#F3F3F3","strokeWidth":"2","key":1})]);
}

Next.defaultProps = {"width":"39","height":"15","viewBox":"0 0 39 15","fill":"none"};

module.exports = Next;

Next.default = Next;
